"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestInSlotBrc20 = void 0;
const tools_1 = require("../../utils/tools");
class BestInSlotBrc20 {
    constructor({ token, }, testnet = false) {
        const baseUrl = testnet ? "https://testnet.api.bestinslot.xyz" : "https://api.bestinslot.xyz";
        this.api = (0, tools_1.getAxiosInstance)({
            baseUrl,
            headers: {
                "x-api-key": token,
            },
        });
    }
    getBrc20InscriptionInfo(inscriptionId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/single_info`, {
                params: {
                    inscription_id: inscriptionId,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            if (response.data === "no-data") {
                return;
            }
            return response.data;
        });
    }
    getBrc20TickerInfo(ticker) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/ticker_info`, {
                params: {
                    ticker,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20TickerTxHistory(ticker, offset = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/validtxnotes`, {
                params: {
                    ticker,
                    sort_by: "inscr_num",
                    order: "asc",
                    offset,
                    count: 20 * 3,
                    exclude_brc20: false,
                    cursed_only: false,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressTickerTxHistory(address, ticker, offset = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/validtxnotes_wallet`, {
                params: {
                    ticker,
                    address,
                    sort_by: "inscr_num",
                    order: "asc",
                    offset,
                    count: 20 * 3,
                    exclude_brc20: false,
                    cursed_only: false,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressBalances(address) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/wallet_balances`, {
                params: {
                    address,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressBalanceForTicker(address, ticker) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/brc20/wallet_balances`, {
                params: {
                    address,
                    ticker,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data[0];
        });
    }
    getCollections() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/collection/collections`, {
                params: {
                    sort_by: "supply",
                    order: "asc",
                    offset: 0,
                    count: 20 * 3,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response;
        });
    }
    getCollectionInfo(slug) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/collection/info`, {
                params: {
                    slug,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response;
        });
    }
    getCollectionInscriptions(slug, offset = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/collection/inscriptions`, {
                params: {
                    slug,
                    sort_by: "inscr_num",
                    order: "asc",
                    offset,
                    count: 20 * 3,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response;
        });
    }
    getWalletInscriptions(address, offset = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/wallet/inscriptions`, {
                params: {
                    address,
                    sort_by: "inscr_num",
                    order: "asc",
                    offset,
                    count: 20 * 3,
                    exclude_brc20: false,
                    cursed_only: false,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response;
        });
    }
    getWalletSatNames(address, offset = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v3/wallet/sats_names`, {
                params: {
                    address,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response;
        });
    }
}
exports.BestInSlotBrc20 = BestInSlotBrc20;
exports.default = BestInSlotBrc20;
//# sourceMappingURL=best-in-slot.api.js.map